/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addFacilityStatusReport } from '../fn/facility-status-report/add-facility-status-report';
import { AddFacilityStatusReport$Params } from '../fn/facility-status-report/add-facility-status-report';
import { deleteFacilityStatusReport } from '../fn/facility-status-report/delete-facility-status-report';
import { DeleteFacilityStatusReport$Params } from '../fn/facility-status-report/delete-facility-status-report';
import { FacilityStatusReportDto } from '../models/facility-status-report-dto';
import { getFacilityStatusReports } from '../fn/facility-status-report/get-facility-status-reports';
import { GetFacilityStatusReports$Params } from '../fn/facility-status-report/get-facility-status-reports';
import { getPerformanceReports } from '../fn/facility-status-report/get-performance-reports';
import { GetPerformanceReports$Params } from '../fn/facility-status-report/get-performance-reports';
import { MedicinesBookDto } from '../models/medicines-book-dto';
import { PerformancePageDto } from '../models/performance-page-dto';
import { updateFacilityStatusReport } from '../fn/facility-status-report/update-facility-status-report';
import { UpdateFacilityStatusReport$Params } from '../fn/facility-status-report/update-facility-status-report';

@Injectable({ providedIn: 'root' })
export class FacilityStatusReportService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `addFacilityStatusReport()` */
  static readonly AddFacilityStatusReportPath = '/api/facilitystatusreport';

  /**
   * Add Facility Status Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addFacilityStatusReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addFacilityStatusReport$Response(params: AddFacilityStatusReport$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityStatusReportDto>> {
    return addFacilityStatusReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Facility Status Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addFacilityStatusReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addFacilityStatusReport(params: AddFacilityStatusReport$Params, context?: HttpContext): Observable<FacilityStatusReportDto> {
    return this.addFacilityStatusReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityStatusReportDto>): FacilityStatusReportDto => r.body)
    );
  }

  /** Path part for operation `getFacilityStatusReports()` */
  static readonly GetFacilityStatusReportsPath = '/api/facilitystatusreport/medbook/{customerId}/{facilityGroupId}/{facilityId}';

  /**
   * Get Facility Status Reports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFacilityStatusReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityStatusReports$Response(params: GetFacilityStatusReports$Params, context?: HttpContext): Observable<StrictHttpResponse<MedicinesBookDto>> {
    return getFacilityStatusReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Facility Status Reports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFacilityStatusReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFacilityStatusReports(params: GetFacilityStatusReports$Params, context?: HttpContext): Observable<MedicinesBookDto> {
    return this.getFacilityStatusReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<MedicinesBookDto>): MedicinesBookDto => r.body)
    );
  }

  /** Path part for operation `getPerformanceReports()` */
  static readonly GetPerformanceReportsPath = '/api/facilitystatusreport/performance';

  /**
   * Get Performance Reports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPerformanceReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerformanceReports$Response(params?: GetPerformanceReports$Params, context?: HttpContext): Observable<StrictHttpResponse<PerformancePageDto>> {
    return getPerformanceReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Performance Reports.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPerformanceReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPerformanceReports(params?: GetPerformanceReports$Params, context?: HttpContext): Observable<PerformancePageDto> {
    return this.getPerformanceReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<PerformancePageDto>): PerformancePageDto => r.body)
    );
  }

  /** Path part for operation `updateFacilityStatusReport()` */
  static readonly UpdateFacilityStatusReportPath = '/api/facilitystatusreport/{facilityStatusReportId}';

  /**
   * Update Facility Status Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFacilityStatusReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityStatusReport$Response(params: UpdateFacilityStatusReport$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityStatusReportDto>> {
    return updateFacilityStatusReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Facility Status Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFacilityStatusReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFacilityStatusReport(params: UpdateFacilityStatusReport$Params, context?: HttpContext): Observable<FacilityStatusReportDto> {
    return this.updateFacilityStatusReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<FacilityStatusReportDto>): FacilityStatusReportDto => r.body)
    );
  }

  /** Path part for operation `deleteFacilityStatusReport()` */
  static readonly DeleteFacilityStatusReportPath = '/api/facilitystatusreport/{facilityStatusReportId}';

  /**
   * Delete Facility Status Report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFacilityStatusReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityStatusReport$Response(params: DeleteFacilityStatusReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFacilityStatusReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Facility Status Report.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFacilityStatusReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFacilityStatusReport(params: DeleteFacilityStatusReport$Params, context?: HttpContext): Observable<void> {
    return this.deleteFacilityStatusReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
